'use client';

import { ReviewResponseCGType, UserCGType } from '@/types/graphql/root';
import { signinWithZzimToken } from '@/utils/actions';
import { useEffect, useMemo, useState } from 'react';
import HoolzzukReview from './hoolzzuk-review';
import { filterNullUndefined } from '@/utils';
import GoogleReview from './google-reviews';

export default function PoiDetailReviews({ reviews }: { reviews: ReviewResponseCGType | null }) {
  const [account, setAccount] = useState<UserCGType | null>(null);

  useEffect(() => {
    signinWithZzimToken().then((account) => {
      setAccount(account?.user ?? null);
    });
  }, []);

  const groupedReviews = useMemo(() => {
    return {
      google: filterNullUndefined(reviews?.reviews?.filter((review) => review?.provider === 'google')),
      hoolzzuk: filterNullUndefined(reviews?.reviews?.filter((review) => review?.provider === 'hoolzzuk')),
    };
  }, [reviews]);

  if (!reviews) return null;

  return (
    <div id='poi-detail-reviews'>
      <div id='poi-detail-reviews' className='bg-white'>
        <p className='text-gray-800 heading-16-b px-20pxr pt-24pxr'>리뷰</p>
        {/* {groupedReviews.hoolzzuk.length > 0 &&
          groupedReviews.hoolzzuk.map((hoolzzukReview, index) => (
            <HoolzzukReview
              key={`hoolzzukReview_${index}`}
              review={hoolzzukReview}
              account={account}
            />
          ))} */}
        {groupedReviews.google.length > 0 && <GoogleReview reviews={groupedReviews.google} />}
      </div>
    </div>
  );
}
